import { ToasterPositionEnum } from '@shared/enums';

export class ToasterHelper {
    static error(
        message: string = "Something didn't quite go as planned. Please try again later.",
        title: string = 'Error'
    ) {
        return {
            key: ToasterPositionEnum.TOP_CENTER,
            severity: 'error',
            summary: title,
            detail: message,
            icon: 'pi-minus-circle',
        };
    }

    static warning(message: string, title: string = 'Warning') {
        return {
            key: ToasterPositionEnum.TOP_CENTER,
            severity: 'warn',
            summary: title,
            detail: message,
            icon: 'pi-exclamation-triangle',
        };
    }

    static success(message: string, title: string = 'Success') {
        return {
            key: ToasterPositionEnum.BOTTOM_RIGHT,
            severity: 'success',
            summary: title,
            detail: message,
            icon: 'pi-check-square',
        };
    }

    static info(message: string, title: string = 'Info') {
        return {
            key: ToasterPositionEnum.TOP_CENTER,
            severity: 'info',
            summary: title,
            detail: message,
            icon: 'pi-exclamation-circle',
        };
    }
}
